import { Check, X } from "lucide-react";
import Reveal from "../landing/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function PullPush() {
  const { t } = useLanguage();

  return (
    <section className="bg-cream-dark/50 py-20 md:py-28" data-testid="pullpush-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <p className="kicker" data-testid="pullpush-kicker">{t.pullpush.kicker}</p>
          <h2 className="mt-5 max-w-4xl font-display text-3xl font-bold leading-tight text-forest-800 md:text-4xl lg:text-5xl">
            {t.pullpush.title}
          </h2>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-forest-800/80">{t.pullpush.lead}</p>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          <Reveal>
            <div className="h-full border-t-2 border-forest-800/40 bg-cream p-8" data-testid="pull-card">
              <p className="font-body text-[11px] font-bold uppercase tracking-[0.25em] text-forest-800/50">
                {t.pullpush.pullTitle}
              </p>
              <h3 className="mt-2 font-display text-2xl font-bold text-forest-800/70">{t.pullpush.pullHead}</h3>
              <ul className="mt-6 space-y-4">
                {t.pullpush.pull.map((item) => (
                  <li key={item} className="rule flex items-start gap-3 pt-4 text-sm text-forest-800/70">
                    <X size={15} className="mt-0.5 shrink-0 text-forest-800/40" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="card-lift h-full border-t-2 border-ember bg-white p-8 shadow-lg shadow-forest-900/10" data-testid="push-card">
              <p className="font-body text-[11px] font-bold uppercase tracking-[0.25em] text-ember">
                {t.pullpush.pushTitle}
              </p>
              <h3 className="mt-2 font-display text-2xl font-bold text-forest-800">{t.pullpush.pushHead}</h3>
              <ul className="mt-6 space-y-4">
                {t.pullpush.push.map((item) => (
                  <li key={item} className="rule flex items-start gap-3 pt-4 text-sm text-forest-800">
                    <Check size={15} className="mt-0.5 shrink-0 text-ember" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal className="mt-14">
          <h3 className="font-display text-2xl font-bold text-forest-800" data-testid="fails-title">{t.pullpush.failsTitle}</h3>
          <div className="mt-7 grid gap-8 md:grid-cols-3">
            {t.pullpush.fails.map((fail) => (
              <div key={fail.t} className="rule pt-5">
                <h4 className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-ember">{fail.t}</h4>
                <p className="mt-3 text-sm leading-relaxed text-forest-800/75">{fail.d}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="mt-14">
          <div className="border-t-2 border-forest-800 pt-8">
            <blockquote className="max-w-4xl font-display text-xl italic leading-relaxed text-forest-800 md:text-2xl" data-testid="pullpush-quote">
              “{t.pullpush.quote}”
            </blockquote>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
